import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const NotificationBell = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const unread = items.filter((n) => !n.read).length;

  const onOpen = (o) => { if (!o && unread) api.post("/notifications/read-all").then(load); };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button className="relative rounded-md border border-slate-200 p-2 text-slate-600 hover:bg-slate-100" data-testid="notifications-btn" title="Notifications">
          <Bell className="h-4 w-4" />
          {unread > 0 && <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-bold text-white" data-testid="notifications-count">{unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notifications-panel">
        <p className="border-b px-4 py-2 text-sm font-semibold">Notifications</p>
        <div className="max-h-96 overflow-y-auto">
          {items.length ? items.map((n) => (
            <button key={n.id} onClick={() => n.link && navigate(n.link)} className={`block w-full border-b px-4 py-3 text-left text-xs hover:bg-slate-50 ${n.read ? "" : "bg-red-50/60"}`}>
              <p className="font-semibold text-slate-900">{n.title}</p>
              <p className="mt-0.5 text-slate-600">{n.body}</p>
              <p className="mt-1 text-[10px] text-slate-400">{new Date(n.created_at).toLocaleString("fr-FR")}</p>
            </button>
          )) : <p className="px-4 py-6 text-center text-xs text-slate-500">Aucune notification.</p>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
